"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApproveERC20SpenderStep = void 0;
const step_1 = require("../../step");
const erc20_contract_1 = require("../../../contract/token/erc20-contract");
const token_1 = require("../../../utils/token");
const no_action_output_1 = require("../../../utils/no-action-output");
const big_number_1 = require("../../../utils/big-number");
const shared_models_1 = require("@railgun-community/shared-models");
class ApproveERC20SpenderStep extends step_1.Step {
    constructor(spender, tokenInfo, amount) {
        super();
        this.config = {
            name: 'Approve ERC20 Spender',
            description: 'Approves ERC20 for spender contract.',
        };
        this.spender = spender;
        this.tokenInfo = tokenInfo;
        this.amount = amount;
    }
    async getStepOutput(input) {
        if (!(0, shared_models_1.isDefined)(this.spender) || (this.tokenInfo.isBaseToken ?? false)) {
            return (0, no_action_output_1.createNoActionStepOutput)(input);
        }
        const { erc20Amounts, networkName } = input;
        const { erc20AmountForStep, unusedERC20Amounts } = this.getValidInputERC20Amount(erc20Amounts, erc20Amount => (0, token_1.compareERC20Info)(erc20Amount, this.tokenInfo) &&
            erc20Amount.approvedSpender !== this.spender, this.amount);
        const contract = new erc20_contract_1.ERC20Contract(erc20AmountForStep.tokenAddress);
        const approveAmount = this.amount ?? (0, big_number_1.maxBigNumberForTransaction)();
        const crossContractCalls = [];
        if (this.requiresClearApprovalTransaction(networkName, erc20AmountForStep.tokenAddress)) {
            crossContractCalls.push(await contract.createSpenderApproval(this.spender, 0n));
        }
        crossContractCalls.push(await contract.createSpenderApproval(this.spender, approveAmount));
        const approvedERC20Amount = {
            tokenAddress: erc20AmountForStep.tokenAddress,
            decimals: erc20AmountForStep.decimals,
            isBaseToken: erc20AmountForStep.isBaseToken,
            expectedBalance: (0, big_number_1.minBigNumber)(approveAmount, erc20AmountForStep.expectedBalance),
            minBalance: (0, big_number_1.minBigNumber)(approveAmount, erc20AmountForStep.minBalance),
            approvedSpender: this.spender,
        };
        return {
            crossContractCalls,
            outputERC20Amounts: [approvedERC20Amount, ...unusedERC20Amounts],
            outputNFTs: input.nfts,
        };
    }
    requiresClearApprovalTransaction(networkName, tokenAddress) {
        switch (networkName) {
            case shared_models_1.NetworkName.Ethereum:
                if ([
                    '0xdac17f958d2ee523a2206206994597c13d831ec7',
                ].includes(tokenAddress.toLowerCase())) {
                    return true;
                }
                return false;
            case shared_models_1.NetworkName.Railgun:
            case shared_models_1.NetworkName.BNBChain:
            case shared_models_1.NetworkName.Polygon:
            case shared_models_1.NetworkName.Arbitrum:
            case shared_models_1.NetworkName.EthereumRopsten_DEPRECATED:
            case shared_models_1.NetworkName.EthereumGoerli:
            case shared_models_1.NetworkName.PolygonMumbai:
            case shared_models_1.NetworkName.ArbitrumGoerli:
            case shared_models_1.NetworkName.Hardhat:
                return false;
        }
    }
}
exports.ApproveERC20SpenderStep = ApproveERC20SpenderStep;
